module.exports = __webpack_public_path__ + "img/banner-les-collectionneurs.4436364b.png";